// Zentrale Link-Klassifizierung fuer automatische Extern-Kennzeichnung.
const OWN_HOSTS = (() => {
  const hosts = new Set();
  const add = (h) => { if (!h) return; const c = String(h).toLowerCase().replace(/^www\./, ''); if (c) hosts.add(c); };
  add('reitverein-hollewuesting.de');
  try { const b = process.env.REACT_APP_BACKEND_URL; if (b) add(new URL(b).hostname); } catch { /* leer/ungueltig ignorieren */ }
  if (typeof window !== 'undefined' && window.location?.hostname) add(window.location.hostname);
  return hosts;
})();
const ORIGIN = (typeof window !== 'undefined' && window.location) ? window.location.origin : 'https://reitverein-hollewuesting.de';

export function classifyHref(href) {
  const raw = typeof href === 'string' ? href.trim() : '';
  if (!raw || raw === '#') return { kind: 'unknown', scheme: '', host: null };
  if (raw.startsWith('#') || raw.startsWith('?')) return { kind: 'internal', scheme: '', host: null };
  const m = raw.match(/^([a-z][a-z0-9+.-]*):/i);
  const scheme = m ? m[1].toLowerCase() : '';
  if (scheme === 'mailto') return { kind: 'mail', scheme, host: null };
  if (scheme === 'tel') return { kind: 'tel', scheme, host: null };
  if (['javascript','data','blob','vbscript'].includes(scheme)) return { kind: 'unknown', scheme, host: null };
  let url; try { url = new URL(raw, ORIGIN); } catch { return { kind: 'unknown', scheme, host: null }; }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return { kind: 'unknown', scheme: url.protocol.replace(':',''), host: url.hostname || null };
  const host = url.hostname.toLowerCase().replace(/^www\./, '');
  return { kind: OWN_HOSTS.has(host) ? 'internal' : 'external', scheme: url.protocol.replace(':',''), host };
}
export function isExternalUrl(href) { return classifyHref(href).kind === 'external'; }
export function isRouterPath(href) {
  const raw = typeof href === 'string' ? href.trim() : '';
  if (!raw) return false;
  if (raw.startsWith('/api/')) return false;
  return (/^\/(?!\/)/.test(raw)) || raw.startsWith('#') || raw.startsWith('?');
}
